import React from "react";
import "./App.scss";
import MainContainer from "./containers/index";

function App() {
  return (
    <div>
      <MainContainer />
    </div>
  );
}

export default App;
